<template>
	<div class="modal">
		<div class="row">
			<div class="col-md-12 end-sm end-md end-lg">
				<a @click="close()"><span class="fa-light fa-circle-xmark textXlg textGrey"></span></a>
			</div>
		</div>
		<div class="row margin-b40">
			<div class="col-md-12 mx-auto">
				<p class="textGrey textLg textCenter">Carrier ID List</p>
			</div>
		</div>

		<div class="row margin-b50">
			<div class="col-xs-12 col-sm-12 col-md-8 col-lg-6 col-md-offset-2 col-lg-offset-3">
				<div class="card formPanel">
					<div class="content">
						<div class="col-xs-12">
							<div class="listHeader">
								<div class="row">
									<div class="col-xs-3 col-sm-2 col-md-2 col-lg-2">
										<p>ID</p>
									</div>
									<div class="col-xs-4 col-sm-5 col-md-5 col-lg-5">
										<p>Name</p>
									</div>
									<div v-if="tenants?.length > 1" class="col-xs-4 col-sm-5 col-md-5 col-lg-5">
										<p>Tenant</p>
									</div>
								</div>
							</div>
						</div>
						<div class="row content middle-sm middle-md middle-lg">
							<div class="col-xs-12">
								<router-link
									v-for="carrier in carriers"
									:key="carrier.id"
									:to="`/carriers/${carrier.id}`"
									target="_blank"
									class="card listItem group flex w-full items-center py-4"
								>
									<div class="flex-[0.2]">
										<p>{{ carrier.id }}</p>
									</div>
									<div class="flex-[0.4]">
										<p>{{ carrier.name }}</p>
									</div>
									<div v-if="tenants?.length > 1" class="flex-[0.4]">
										<p>{{ carrier.tenant ? carrier.tenant.companyName : 'Unassigned' }}</p>
									</div>
									<span
										class="fa-light fa-arrow-right opacity-0 transition-opacity group-hover:opacity-100"
									>
									</span>
								</router-link>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>

		<div class="row margin-b20">
			<div class="col-md-12 mx-auto">
				<ul class="stepBtns">
					<li><a class="jmiBtn btnLg red" @click="close()">Close</a></li>
				</ul>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	inject: ['user', 'userRoles', 'showCarrierList', 'tenants'],
	props: ['carriers'],
	emits: ['close'],
	mounted() {
		document.addEventListener('keyup', this.onKeyUp)
	},
	beforeUnmount() {
		document.removeEventListener('keyup', this.onKeyUp)
	},
	methods: {
		close() {
			this.showCarrierList = false
		},
		onKeyUp(event) {
			if (event.key == 'Escape') this.close()
		},
		newRoute(routeName) {
			window.open(routeName, '_blank')
		}
	}
}
</script>
